import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '#pplx/frontend/aether/components/Icon/index.js';
import { orgAdminSidebarInviteButtonClickedEvent, sidebarMenuItemClickedEvent, } from '#pplx/frontend/apps/ask/events/sidebar/analytics.js';
import { SidebarBottomItem } from '#pplx/frontend/apps/ask/layout/sidebar/core/shared/SidebarBottomItem.js';
import { useGetSettingsPrefix } from '#pplx/frontend/apps/ask/settings/hooks/useGetSettingsRoute.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { useRouter } from '#pplx/frontend/router/provider.js';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
export const SidebarEnterpriseInviteButton = () => {
    const { $t } = useIntl();
    const { track } = useInstrumentation();
    const settingsPrefix = useGetSettingsPrefix();
    const router = useRouter();
    const label = $t({
        defaultMessage: 'Add org members',
        description: 'Sidebar button label for org admins to navigate to the org members page to invite org members',
        id: '7fb1b49b1d',
    });
    const handleClick = useCallback(() => {
        track(orgAdminSidebarInviteButtonClickedEvent);
        track(sidebarMenuItemClickedEvent({
            name: 'sidebar menu item clicked',
            data: {
                tabType: 'org invite',
                location: 'sidebar',
            },
        }));
        router.push(`${settingsPrefix}/org/members`);
    }, [track, router, settingsPrefix]);
    return (_jsx(SidebarBottomItem.Root, { isExpanded: true, children: _jsx(SidebarBottomItem.Leading, { tooltip: label, label: label, onClick: handleClick, children: _jsx(Icon, { icon: $icon('user-plus'), size: "medium" }) }) }));
};
//# sourceMappingURL=SidebarEnterpriseInviteButton.js.map